import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import Header from './components/Header';
import Footer from './components/footer/Footer';
import VideoDetailView from './components/VideoDetailView';

import InicioContent from './components/tabs/InicioContent';
import FilmesContent from './components/tabs/FilmesContent';
import GamesContent from './components/tabs/GamesContent';
import CategoryDetailView from './components/CategoryDetailView';
import SearchResultsView from './components/SearchResultsView'; // 👈 Importação limpa do componente isolado

import PlayFeedMain from './components/tabs/playfeed/PlayFeedMain';

import ShortsFeed from './components/tabs/ShortsPage';
import { useLocation } from 'react-router-dom';

export default function WebPlayer() {
  const [videos, setVideos] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const getInitialTab = () => {
    if (location.pathname.includes('/games')) return 'games';
    if (location.pathname.includes('/filmes')) return 'filmes';
    if (location.pathname.includes('/shorts')) return 'shorts';
    if (location.pathname.includes('/playfeed')) return 'playfeed';
    return 'inicio';
  };

  const [currentTab, setCurrentTab] = useState(getInitialTab);

  useEffect(() => {
    setCurrentTab(getInitialTab());
  }, [location.pathname]);

  const [searchQuery, setSearchQuery] = useState('');
  const [activeVideo, setActiveVideo] = useState<any | null>(null);
  const [viewAllCategory, setViewAllCategory] = useState<string | null>(null);
  const [viewAllVideos, setViewAllVideos] = useState<any[] | undefined>(undefined);

  // Estados da paginação e busca via Supabase (Blindados com limite de 50)
  const [searchPage, setSearchPage] = useState(1);
  const [totalSearchResults, setTotalSearchResults] = useState(0);
  const [paginatedResults, setPaginatedResults] = useState<any[]>([]);
  const ITEMS_PER_PAGE = 10;

  const [loadedSearchImages, setLoadedSearchImages] = useState<{ [key: string]: boolean }>({});

  

useEffect(() => {
  async function fetchInitialVideos() {
    // Puxa tudo (filmes, games, shorts da web), mas ignora o que for exclusivo do app
    const { data, error } = await supabase
      .from('videos')
      .select('*')
      .neq('post_type', 'app_exclusivo')
      .order('created_at', { ascending: false })
      .limit(100); // 🛡️ BLINDAGEM CRÍTICA: Traz apenas os 100 mais recentes para não travar o telemóvel no 4G!

    if (error) {
      console.error("Erro ao buscar vídeos:", error);
    } else if (data) {
      setVideos(data);
    }
    setLoading(false);
  }
  fetchInitialVideos();
}, []);

  // 🔍 Efeito para abrir o vídeo automaticamente via link partilhado (?v=ID)
  // 🔍 Efeito blindado para abrir o vídeo exato automaticamente se o link tiver ?v=ID
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const videoIdFromUrl = params.get('v');
    
    if (videoIdFromUrl) {
      // Força a chamada da função de seleção para buscar no Supabase caso ainda não esteja na lista
      handleSelectVideo(videoIdFromUrl);
    }
  }, [videos]); // Executa assim que os vídeos da página terminam de carregar

  // Função de busca e paginação otimizada direto no Supabase
  const fetchPagedSearch = async (query: string, page: number) => {
    const start = (page - 1) * ITEMS_PER_PAGE;
    const end = start + ITEMS_PER_PAGE - 1;

    const { data, count, error } = await supabase
      .from('videos')
      .select('*', { count: 'exact' })
      .or(`title.ilike.%${query}%,description.ilike.%${query}%,category.ilike.%${query}%`)
      .order('created_at', { ascending: false })
      .range(start, end);

    if (error) {
      console.error('Erro na busca do Supabase:', error);
    } else {
      setPaginatedResults(data || []);
      setTotalSearchResults(count || 0);
    }
  };

  useEffect(() => {
    if (searchQuery && searchQuery.trim() !== '') {
      fetchPagedSearch(searchQuery, searchPage);
    }
  }, [searchQuery, searchPage]);

  const handleSelectVideo = async (id: string) => {
    // 1. Tenta achar o vídeo primeiro na memória local (rápido)
    let videoFound = paginatedResults.find(v => v.id === id) || 
                     videos.find(v => v.id === id) || 
                     viewAllVideos?.find(v => v.id === id);
    
    // 2. BLINDAGEM: Se não estiver na memória, vai buscar diretamente ao Supabase!
    if (!videoFound) {
      console.log('Vídeo não encontrado na memória local. A buscar no Supabase: ', id);
      const { data, error } = await supabase
        .from('videos')
        .select('*')
        .eq('id', id)
        .single();

      if (data) {
        videoFound = data;
      } else {
        console.error('Erro: Este vídeo não foi encontrado no banco de dados!', error);
        return; // Pára tudo se o vídeo realmente não existir
      }
    }
    
    // 3. Processa a abertura do vídeo (Shorts ou Player Normal)
    if (videoFound) {
      const isShort = videoFound.post_type === 'shorts' || 
                      videoFound.is_short === true || 
                      (videoFound.category || '').toLowerCase().includes('shorts');
      
      if (isShort) {
        window.location.href = `/shorts?v=${videoFound.id}`;
        return;
      }

      setActiveVideo(videoFound);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleViewAll = (categoryTitle: string, videosList?: any[]) => {
    setViewAllCategory(categoryTitle);
    setViewAllVideos(videosList);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (viewAllCategory) {
    return (
      <div style={{ backgroundColor: '#000000', minHeight: '100vh' }}>
        <Header 
          currentTab={currentTab} 
          onSelectTab={(tab: string) => { setCurrentTab(tab); setSearchQuery(''); setViewAllCategory(null); setActiveVideo(null); }} 
          onSearch={(query: string) => { setSearchQuery(query); setSearchPage(1); setViewAllCategory(null); setActiveVideo(null); }} 
          onSelectVideo={handleSelectVideo} 
        />
        <div style={{ paddingTop: '80px' }}>
          <CategoryDetailView 
            categoryTitle={viewAllCategory} 
            initialVideos={viewAllVideos} 
            onBack={() => {
              setViewAllCategory(null);
              setViewAllVideos(undefined);
            }} 
            onSelectVideo={handleSelectVideo} 
          />
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{ backgroundColor: '#000000', color: '#fff', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '18px' }}>
        Carregando plataforma Doisplay...
      </div>
    );
  }

  if (activeVideo) {
    return (
      <div style={{ backgroundColor: '#000000', minHeight: '100vh' }}>
        <Header 
          currentTab={currentTab} 
          onSelectTab={(tab: string) => { setCurrentTab(tab); setSearchQuery(''); setActiveVideo(null); setViewAllCategory(null); }} 
          onSearch={(query: string) => { setSearchQuery(query); setSearchPage(1); setActiveVideo(null); setViewAllCategory(null); }} 
          onSelectVideo={handleSelectVideo} 
        />
        <div style={{ paddingTop: '80px' }}>
          <VideoDetailView 
            video={activeVideo} 
            allVideos={videos} 
            onBack={() => setActiveVideo(null)} 
            onSelectVideo={handleSelectVideo} 
          />
        </div>
      </div>
    );
  }

  const filteredVideos = videos;

  return (
    <div style={{ backgroundColor: '#000000', color: '#fff', minHeight: '100vh', fontFamily: 'system-ui, sans-serif', position: 'relative' }}>
      <Header 
        currentTab={currentTab} 
        onSelectTab={(tab: string) => { 
           setCurrentTab(tab); 
           setSearchQuery('');
        }} 
        onSearch={(query: string) => {
          setSearchQuery(query);
          setSearchPage(1);
        }} 
        onSelectVideo={handleSelectVideo}
      />
      
      <div style={{ paddingTop: '80px' }}>
        {searchQuery && searchQuery.trim() !== '' ? (
          <SearchResultsView 
            searchQuery={searchQuery}
            totalSearchResults={totalSearchResults}
            paginatedResults={paginatedResults}
            searchPage={searchPage}
            ITEMS_PER_PAGE={ITEMS_PER_PAGE}
            loadedSearchImages={loadedSearchImages}
            setLoadedSearchImages={setLoadedSearchImages}
            onSelectVideo={handleSelectVideo}
            onPageChange={(newPage) => {
              setSearchPage(newPage);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          />
        ) : (
          <>
            {currentTab === 'inicio' && (
              <InicioContent videos={filteredVideos} onSelectVideo={handleSelectVideo} handleViewAll={handleViewAll} />
            )}
            {currentTab === 'filmes' && (
              <FilmesContent videos={filteredVideos} onSelectVideo={handleSelectVideo} handleViewAll={handleViewAll} />
            )}
            {currentTab === 'games' && (
              <GamesContent videos={filteredVideos} onSelectVideo={handleSelectVideo} handleViewAll={handleViewAll} />
            )}
            {currentTab === 'shorts' && (
  <ShortsFeed />
)}

{/* 👇 NOVA PONTE DO PLAYFEED AQUI 👇 */}
            {currentTab === 'playfeed' && (
              <PlayFeedMain/>
            )}
          </>
        )}
      </div>
    </div>
  );
}